/* 
  OWN_EXPERT: an expert that is either an employee of the company or external
  PSG_EXPERT: a psg expert
  NO_INTERPRETATION: does not want an interpretation
  NOT_FILLED_IN: the choice has not yet been filled in
*/
export enum InterpretationChoice {
  OWN_EXPERT = 'OWN_EXPERT',
  PSG_EXPERT = 'PSG_EXPERT',
  NO_INTERPRETATION = 'NO_INTERPRETATION',
  NOT_FILLED_IN = 'NOT_FILLED_IN',
}
